import {useCustomerKicoins} from '@/framework/cart';
import React from 'react';

export function KicoinBalanceMobile() {
    const {data: customerKicoins} = useCustomerKicoins();
    return (
        <div className="ml-1">
            <p className="text-xs">Kicoin</p>
            <p className="text-sm text-primary">
                <strong>{customerKicoins?.customerKicoin?.balance ?? 0}</strong>
            </p>
        </div>
    );
}
